var runtime = require("../../../../../build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"container":"_17Jus"};
module.exports._getCss = function(wrap, process){return ""+wrap+" *,"+wrap+" :after,"+wrap+" :before{box-sizing:inherit}"+wrap+" ._17Jus{background-color:"+process("color(--wix-colors-backgroundColor)")+";box-sizing:border-box}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

